window.addEventListener("load", function() {

    animations();
    fixedHeader();
    menu();
    modalVideo();
    adjustHeights();
    smoothScroll();
    backToTop();

    window.addEventListener("scroll", function() {

        fixedHeader();

    });

});